import { type Common } from './common.js';
import {
  type CreateValues,
  type Created,
  type DisplayableFrontDeskDevice,
  type UpdateValues,
} from './models/frontDeskDevice.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';

export interface FindAllOptions {
  practiceId?: string;
  registered?: boolean;
}

export class API {
  common: Common;
  baseEndpoint = '/front-desk-devices';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllPaginated(
    options: FindAllOptions
  ): Promise<PaginationResponse<DisplayableFrontDeskDevice>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<DisplayableFrontDeskDevice> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<Created> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async reset(id: string): Promise<DisplayableFrontDeskDevice> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/reset`);
    return await this.common.postJSON(url, {});
  }

  async update(id: string, values: UpdateValues): Promise<DisplayableFrontDeskDevice> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
